export const paths = {
  image: 'M3 3h18v18H3z M3 17l6-6 4 4 3-3 5 5 M8 7h.01',
  refresh: 'M20 7V2l-4 4 M4 17v5l4-4 M20 7a9 9 0 0 0-16 1 M4 17a9 9 0 0 0 16-1',
  bulb: 'M9 18h6 M9 21h6 M8 14a6 6 0 1 1 8 0l-1 3H9z',
  mic: 'M9 4a3 3 0 0 1 6 0v8a3 3 0 0 1-6 0z M5 10v2a7 7 0 0 0 14 0v-2 M12 19v3 M8 22h8',
  keyboard:
    'M2 5h20v14H2z M5 9h1 M9 9h1 M13 9h1 M17 9h1 M5 12h1 M9 12h1 M13 12h1 M17 12h1 M6 16h12',
  stop: 'M6 6h12v12H6z',
  cards: 'M5 4h14v16H5z M8 1h14v16',
  search: 'M21 21l-5-5 M18 10a8 8 0 1 1-16 0 8 8 0 0 1 16 0',
  filter: 'M3 5h18 M6 12h12 M10 19h4',
  dots: 'M4 12a1 1 0 1 0 2 0 1 1 0 1 0-2 0 M11 12a1 1 0 1 0 2 0 1 1 0 1 0-2 0 M18 12a1 1 0 1 0 2 0 1 1 0 1 0-2 0',
  wand: 'M4 20l-1-1 13-13 3 3L6 22z M13 9l3 3 M5 3v4 M3 5h4 M19 15v4 M17 17h4 M19 2v4 M17 4h4',
  plus: 'M12 5v14 M5 12h14',
  close: 'M6 6l12 12 M18 6L6 18',
  check: 'M5 12l4 4L19 6',
  edit: 'M14 4l6 6 M4 20l5-1L21 7l-4-4L4 16z',
  trash: 'M3 6h18 M9 6V3h6v3 M6 6l1 15h10l1-15 M10 10v7 M14 10v7',
  download: 'M12 3v12 M7 10l5 5 5-5 M4 17v4h16v-4',
  sheet: 'M5 3h14v18H5z M5 9h14 M5 15h14 M12 9v12',
  sparkle: 'M12 3l3 6 6 3-6 3-3 6-3-6-6-3 6-3z',
  speaker: 'M11 4L5 9H2v6h3l6 5z M15 8a6 6 0 0 1 0 8 M18 4a11 11 0 0 1 0 16',
  left: 'M15 5l-7 7 7 7',
  right: 'M9 5l7 7-7 7',
  clock: 'M12 8v4l3 2 M22 12a10 10 0 1 1-20 0 10 10 0 0 1 20 0',
  book: 'M12 5v16 M12 5C8 2 4 3 2 4v16c4-2 7-1 10 1 3-2 6-3 10-1V4c-2-1-6-2-10 1z',
  chat: 'M21 11a9 9 0 0 1-9 9H4l-3 2 2-7a9 9 0 1 1 18-4z',
  translate: 'M2 5h12 M8 2v3 M4 8c2 5 5 7 9 8 M12 5c-1 6-4 10-9 12 M13 21l4-11 5 11 M15 17h5',
  lock: 'M6 10h12v11H6z M8 10V6a4 4 0 0 1 8 0v4',
  info: 'M12 11v6 M12 7h.01 M22 12a10 10 0 1 1-20 0 10 10 0 0 1 20 0',
  flame: 'M12 2c1 5 6 6 6 12a6 6 0 0 1-12 0c0-3 2-5 3-7 0 3 2 4 2 4s2-3 1-9z',
  podcast: 'M4 14v-3a8 8 0 0 1 16 0v3 M4 12H2v7h4z M20 12h2v7h-4v-7z',
  help: 'M9 8a3 3 0 1 1 5 2c-2 1-2 2-2 3 M12 17h.01 M22 12a10 10 0 1 1-20 0 10 10 0 0 1 20 0'
}
